exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.unsub-input input[data-v-64eaa970] {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n}\n.unsub-input button[data-v-64eaa970] {\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n}\n", ""]);

// exports
